<div class="catalogue-page container py-4">
  <div class="catalogue-header mb-4">
    <div class="d-flex flex-wrap justify-content-between align-items-start gap-3">
      <div>
        <h1 class="catalogue-title mb-2">Signup Template Catalogue</h1>
        <p class="catalogue-subtitle mb-0">
          Browse community signup templates. Moderators can import them into a server
          or share their own from the guild dashboard.
        </p>
      </div>
      <div class="d-flex flex-wrap gap-2">
        <a *ngIf="isLoggedIn" routerLink="/templates/mine" class="btn btn-outline-primary">
          My templates
        </a>
        <a *ngIf="isBotOwner" routerLink="/templates/review" class="btn btn-outline-warning">
          Review queue
        </a>
      </div>
    </div>
  </div>

  <div class="filter-bar row g-3 align-items-end mb-4">
    <div class="col-md-6">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Search</mat-label>
        <input matInput [formControl]="searchControl" placeholder="Title, description, game…" />
        <mat-icon matPrefix>search</mat-icon>
      </mat-form-field>
    </div>
    <div class="col-md-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Game</mat-label>
        <mat-select [(ngModel)]="selectedGameId" (selectionChange)="onGameChange()">
          <mat-option [value]="null">All games</mat-option>
          <mat-option *ngFor="let game of games" [value]="game.id">{{ game.name }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-md-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Sort</mat-label>
        <mat-select [(ngModel)]="sort" (selectionChange)="onSortChange()">
          <mat-option value="newest">Newest</mat-option>
          <mat-option value="likes">Most liked</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div *ngIf="loading && templates.length === 0" class="text-center py-5">
    <mat-spinner diameter="40" class="mx-auto"></mat-spinner>
  </div>

  <div *ngIf="!loading && templates.length === 0" class="empty-state text-center py-5">
    <mat-icon class="empty-icon">inventory_2</mat-icon>
    <p class="mb-0">No templates match your filters yet.</p>
  </div>

  <div *ngIf="templates.length" class="catalogue-grid">
    <a
      *ngFor="let template of templates"
      class="catalogue-card"
      [routerLink]="['/templates', template.id]"
    >
      <div class="card-body">
        <div class="card-top">
          <h2 class="card-title mb-0">{{ template.title }}</h2>
          <span class="version-chip" title="Template version">v{{ template.version }}</span>
        </div>
        <div class="game-label">{{ template.game || 'Unknown game' }}</div>
        <p class="card-description">{{ template.description }}</p>
        <div class="card-footer">
          <div class="card-votes">
            <span><mat-icon>thumb_up</mat-icon> {{ template.like_count }}</span>
            <span><mat-icon>thumb_down</mat-icon> {{ template.dislike_count }}</span>
          </div>
          <time
            *ngIf="template.updated_at || template.created_at"
            class="card-updated"
            [attr.datetime]="template.updated_at || template.created_at"
            [attr.title]="'Last updated ' + ((template.updated_at || template.created_at) | date: 'medium')"
          >
            <mat-icon>history</mat-icon>
            {{ (template.updated_at || template.created_at) | date: 'd MMM y' }}
          </time>
        </div>
      </div>
    </a>
  </div>

  <div
    #loadMoreSentinel
    class="load-more-sentinel"
    *ngIf="templates.length && hasMore"
    aria-hidden="true"
  ></div>

  <div *ngIf="loadingMore" class="text-center py-3">
    <mat-spinner diameter="28" class="mx-auto"></mat-spinner>
  </div>

  <p *ngIf="templates.length > 0" class="catalogue-count mt-3 mb-0">
    Showing {{ templates.length }} of {{ total }}
    <span *ngIf="hasMore"> · scroll for more</span>
  </p>
</div>
